"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObject = void 0;
/**
 * Generate an object from an array, key & value mappers
 * @param array The array
 * @param mapToKey Map to the key of the new object
 * @param mapToValue Map to the value of the new object
 * @returns A record of key/value generated by mapping the array with the passed mappers
 */
function toObject(array, mapToKey, mapToValue) {
    // Implemented this way as it seems to have better performance https://jsbench.me/kalaw85v0i
    const obj = {};
    for (let index = 0; index < array.length; index++) {
        obj[mapToKey(array[index], index, array)] = mapToValue(array[index], index, array);
    }
    return obj;
}
exports.toObject = toObject;
//# sourceMappingURL=object.js.map